<template>
    <div>
        <el-form :model="parentInfo.component_updateClassPlan.classPlanForm" label-width="80px">
            <el-form-item label="任课老师:">
                <el-select v-model="parentInfo.component_updateClassPlan.classPlanForm.teacher_id" filterable placeholder="请选择"  @change="changeTeacher()" disabled>
                    <el-option
                            v-for="item in parentInfo.component_updateClassPlan.teachers"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期:" v-if="datax.status">
                <el-date-picker
                        v-model="date"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        @change="handleChangeDate()">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="上课时间:">
                <el-select v-model="parentInfo.component_updateClassPlan.classPlanForm.template_time_semester_id" filterable placeholder="请选择" disabled>
                    <el-option
                            v-for="item in parentInfo.component_updateClassPlan.results"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="教室:">
                <el-select v-model="parentInfo.component_updateClassPlan.classPlanForm.classroom_id" filterable placeholder="请选择" >
                    <el-option
                            v-for="item in parentInfo.component_updateClassPlan.classrooms"
                            :key="item.id"
                            :label="item.complete_name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button v-if="parentInfo.powers.indexOf(108) != -1"  size="small" @click="handleDelete" type="danger" :loading="parentInfo.component_updateClassPlan.button_loading" >删除课时</el-button>
                <el-button  size="small" @click="handleStore" :loading="parentInfo.component_updateClassPlan.button_loading">修改保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "UpdateClassPlan",
        data() {
            return {
               date:''
            }
        },
        created() {
            this.parentInfo = this.$parent.$parent.$parent.$parent;
            this.handleShowClassPlan();
            this.handleGetTeachers("");
        },
        props: {
            datax:{}
        },
        methods: {
            changeTeacher(){
                const teacher_id= this.parentInfo.component_updateClassPlan.classPlanForm.teacher_id;
                this.handleGetTeachers(teacher_id);
            },
            handleGetTeachers(teacher_id){
                this.$wApi.send(this.parentInfo.path, 'get_classPlanDetail', {
                    'classPlan_id':  this.datax.id,
                    'teacher_id': teacher_id,
                });
            },

            handleShowClassPlan() {
                this.parentInfo.component_updateClassPlan.classPlanForm.classPlan_id=this.datax.id;
                this.parentInfo.component_updateClassPlan.classPlanForm.teacher_id=this.datax.teacher_id;
                this.parentInfo.component_updateClassPlan.classPlanForm.start_time=this.datax.start_time;
                this.parentInfo.component_updateClassPlan.classPlanForm.end_time=this.datax.end_time;
                this.date=this.datax.date;
                this.parentInfo.component_updateClassPlan.classPlanForm.date=this.datax.date;
                this.parentInfo.component_updateClassPlan.classPlanForm.classroom_id=this.datax.classroom_id;
                this.parentInfo.component_updateClassPlan.classPlanForm.template_time_semester_id=this.datax.template_time_semester_id;
            },
            handleStore() {
                this.parentInfo.component_updateClassPlan.button_loading = true;
                this.parentInfo.component_updateClassPlan.sign=this.parentInfo.component_updateClassPlan.classPlan.sign;
                if ( this.parentInfo.component_updateClassPlan.sign.finished_student!==0|| this.parentInfo.component_updateClassPlan.sign.leaving_student!==0|| this.parentInfo.component_updateClassPlan.sign.absent_student!==0){
                    this.parentInfo.component_updateClassPlan.button_loading = false;
                    return this.$message({
                        message: '学生已做过签到',
                        type: 'warning'
                    });
                }
                this.$wApi.send(this.parentInfo.path, 'update_classPlan', {
                    'classPlan_id':  this.datax.id,
                    'teacher_id': this.parentInfo.component_updateClassPlan.classPlanForm.teacher_id,
                    'date':this.parentInfo.component_updateClassPlan.classPlanForm.date,
                    'start_time':this.parentInfo.component_updateClassPlan.classPlanForm.start_time,
                    'end_time':this.parentInfo.component_updateClassPlan.classPlanForm.end_time,
                    'classroom_id':this.parentInfo.component_updateClassPlan.classPlanForm.classroom_id,
                });
            },
            handleDelete() {
                this.$confirm('此操作将永久删除该课时, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.parentInfo.component_updateClassPlan.button_loading = true;
                    this.$wApi.send(this.parentInfo.path, 'delete_classPlan', {
                        'classPlan_id':  this.datax.id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleSearchClassroom(query) {
                this.$wApi.send(this.parentInfo.component_updateClassPlan.path, 'search_classroom', {
                    'classPlan_id':  this.datax.id,
                    'classroom_name':query,
                });
            },
            handleChangeDate(){
                this.parentInfo.component_updateClassPlan.classPlanForm.date=this.date
            }
        }
    }
</script>

<style scoped>
    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 99999;
    }

    .modal-dialog {
        max-width: 500px;
        margin: 30px auto;
    }

    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid #e9ecef;
    }

    .modal-header {
        font-size: 12px;
    }

    .modal-title {
        margin: 0;
        line-height: 1.5;
    }

    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 15px;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, .18);
        border-radius: .3rem;
        outline: 0;
        min-height: 300px;
        box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.12);
    }

    .modal .close {
        font-size: 20px;
        text-shadow: 0 1px 0 #fff;
    }

    .modal .close:hover {
        opacity: .5;
    }
</style>
